import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Loader } from "../../atoms/Loader";
import ConnectionList from "./ConnectionList";

function ModuleSetting(props) {
  const {
    children,
    tabIndex,
    index,
    orgId,
    apiKey,
    dataCenterUrl,
    dataCenter,
    activeUsers,
    currentUser,
    zApiKey,
    setSnack,
    ...other
  } = props;

  const [loading, setLoading] = useState(false);

  if (tabIndex != index) {
    return <></>;
  }

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl || !zApiKey) {
    return (
      <>
        Some of the data are missing
        {orgId}-{apiKey}-{dataCenterUrl}-{zApiKey}
      </>
    );
  }

  return (
    <div
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <ConnectionList
        dataCenter={dataCenter}
        orgId={orgId}
        apiKey={apiKey}
        zApiKey={zApiKey}
        setSnack={setSnack}
        activeUsers={activeUsers}
        currentUser={currentUser}
      />
    </div>
  );
}

export default ModuleSetting;
